/**
 * Created by CCristi <ccovali@mitocgroup.com> on 12/10/15.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MethodNotAvailableException = undefined;

var _Exception2 = require('./Exception');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Thrown when a method is not available
 */
let MethodNotAvailableException = exports.MethodNotAvailableException = function (_Exception) {
  _inherits(MethodNotAvailableException, _Exception);

  /**
   * @param {String} name
   */
  function MethodNotAvailableException(name) {
    _classCallCheck(this, MethodNotAvailableException);

    return _possibleConstructorReturn(this, (MethodNotAvailableException.__proto__ || Object.getPrototypeOf(MethodNotAvailableException)).call(this, `Method '${name}' is not available`));
  }

  return MethodNotAvailableException;
}(_Exception2.Exception);


//////////////////
// WEBPACK FOOTER
// ../~/deep-cache/lib.compiled/Driver/Exception/MethodNotAvailableException.js
// module id = 349
// module chunks = 0